/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Select-quote is a show path: selecting a hidden quote needs both fields.
 * @export
 * @interface SelectQuoteBeforeBookingBody
 */
export interface SelectQuoteBeforeBookingBody {
  /**
   *
   * @type {string}
   * @memberof SelectQuoteBeforeBookingBody
   */
  reason?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteBeforeBookingBody
   */
  confirmedWithCarrier: boolean;
}

/**
 * Check if a given object implements the SelectQuoteBeforeBookingBody interface.
 */
export function instanceOfSelectQuoteBeforeBookingBody(
  value: object,
): value is SelectQuoteBeforeBookingBody {
  if (
    !("confirmedWithCarrier" in value) ||
    value["confirmedWithCarrier"] === undefined
  )
    return false;
  return true;
}

export function SelectQuoteBeforeBookingBodyFromJSON(
  json: any,
): SelectQuoteBeforeBookingBody {
  return SelectQuoteBeforeBookingBodyFromJSONTyped(json, false);
}

export function SelectQuoteBeforeBookingBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SelectQuoteBeforeBookingBody {
  if (json == null) {
    return json;
  }
  return {
    reason: json["reason"] == null ? undefined : json["reason"],
    confirmedWithCarrier: json["confirmedWithCarrier"],
  };
}

export function SelectQuoteBeforeBookingBodyToJSON(
  json: any,
): SelectQuoteBeforeBookingBody {
  return SelectQuoteBeforeBookingBodyToJSONTyped(json, false);
}

export function SelectQuoteBeforeBookingBodyToJSONTyped(
  value?: SelectQuoteBeforeBookingBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    reason: value["reason"],
    confirmedWithCarrier: value["confirmedWithCarrier"],
  };
}
